import React from "react";

import BaseLayout from "../../components/layout/BaseLayout";
import AdminRoutes from "../../routes/AdminRoutes";

import { withTheme } from "@emotion/react";
import {
    DashboardIcon,
    RegionsIcon,
    UsersIcon,
    ProductsIcon,
    OrdersIcon,
    LocationOnIcon,
    AssignmentIcon,
    SecurityIcon,
    PersonIcon,
    ReportsIcon,
    AlertsIcon,
} from "../../components/Common/Icons";
import StorefrontOutlinedIcon from "@mui/icons-material/StorefrontOutlined";

const menuIconColor = (active) => ({ color: active ? "#ED2024" : "#575757", fontSize: 22 });

class LayoutContainer extends React.Component {
    render() {
        return <BaseLayout params={this.props.params} modules={adminModules} ChildComponent={AdminRoutes} />;
    }
}
export default withTheme(LayoutContainer);

const adminModules = [
    {
        id: "dashboard",
        title: "Dashboard",
        link: "/dashboard",
        role: ["admin"],
        logo: (active) => [<DashboardIcon active={active} />],
    },
    {
        id: "users",
        title: "Users",
        link: "/users",
        role: ["admin"],
        logo: (active) => <UsersIcon active={active} />,
    },
    {
        id: "customer-master",
        title: "Customer Master",
        link: "/customer-master",
        role: ["admin"],
        logo: (active) => [<PersonIcon active={active} />],
    },
    {
        id: "tracking",
        title: "Live Tracking",
        link: "/tracking",
        role: ["admin"],
        logo: (active) => <LocationOnIcon active={active} />,
    },
    {
        id: "regions",
        title: "Regions",
        link: "/regions",
        role: ["admin"],
        logo: (active) => [<RegionsIcon active={active} />],
    },
    {
        id: "products",
        title: "Products",
        link: "/products",
        role: ["admin"],
        logo: (active) => [<ProductsIcon active={active} />],
    },
    {
        id: "orders",
        title: "Orders",
        link: "/orders",
        role: ["admin"],
        logo: (active) => [<OrdersIcon active={active} />],
    },
    {
        id: "shop",
        title: "Shop",
        role: ["admin"],
        logo: (active) => [<StorefrontOutlinedIcon sx={menuIconColor(active)} />],
        items: [
            { id: "coupons", title: "Coupons", link: "/coupons", role: ["admin"] },
            { id: "referrals", title: "Referral Program", link: "/referrals", role: ["admin"] },
            { id: "shop-settings", title: "Shop Settings", link: "/shop-settings", role: ["admin"] },
        ],
    },
    {
        id: "warranty",
        title: "Warranty",
        link: "/warranty",
        role: ["admin"],
        logo: (active) => [<AssignmentIcon active={active} />],
    },
    {
        id: "insurance",
        title: "Insurance",
        link: "/insurance",
        role: ["admin"],
        logo: (active) => [<SecurityIcon active={active} />],
    },
    {
        id: "reports",
        title: "Reports",
        link: "/reports",
        role: ["admin"],
        logo: (active) => [<ReportsIcon active={active} />],
    },
    {
        id: "alerts",
        title: "Alerts",
        link: "/alerts",
        role: ["admin"],
        logo: (active) => [<AlertsIcon active={active} />],
    },
    // {
    //     id: "customers",
    //     title: "Customers",
    //     role: ["admin"],
    //     logo: (active) => [
    //         <PackageIcon active={active} />
    //     ],
    //     placeholder: ["SUPPLIER", "BUYER"],
    //     items: [
    //         {
    //             id: "supplier-new",
    //             title: "New",
    //             role: ["admin"],
    //             link: "/supplier/new",
    //             placeholder: "SUPPLIER"
    //         },
    //         {
    //             id: "supplier-active",
    //             title: "Active",
    //             role: ["admin"],
    //             link: "/supplier/active",
    //             placeholder: "SUPPLIER"
    //         },
    //         {
    //             id: "supplier-profile",
    //             title: "Profile",
    //             role: ["admin"],
    //             link: "/supplier/profile",
    //             placeholder: "SUPPLIER"
    //         },
    //         {
    //             id: "supplier-rejected",
    //             title: "Rejected",
    //             role: ["admin"],
    //             link: "/supplier/rejected",
    //             placeholder: "SUPPLIER"
    //         },
    //         {
    //             id: "supplier-suspended",
    //             title: "Suspended",
    //             role: ["admin"],
    //             link: "/supplier/suspended",
    //             placeholder: "SUPPLIER"
    //         },
    //         {
    //             id: "buyer-new",
    //             title: "New",
    //             role: ["admin"],
    //             link: "/buyer/new",
    //             placeholder: "BUYER"
    //         },
    //         {
    //             id: "buyer-active",
    //             title: "Active",
    //             role: ["admin"],
    //             link: "/buyer/active",
    //             placeholder: "BUYER"
    //         },
    //         {
    //             id: "buyer-rejected",
    //             title: "Rejected",
    //             role: ["admin"],
    //             link: "/buyer/rejected",
    //             placeholder: "BUYER"
    //         },
    //         {
    //             id: "buyer-suspended",
    //             title: "Suspended",
    //             role: ["admin"],
    //             link: "/buyer/suspended",
    //             placeholder: "BUYER"
    //         },
    //     ]
    // },
    // {
    //     id: "products-crm",
    //     title: "Supplier Products",
    //     role: ["admin"],
    //     logo: (active) => <PackageIcon active={active} />,
    //     items: [
    //         {
    //             id: "products-pending",
    //             title: "Pending",
    //             role: ["admin"],
    //             link: "/products/pending",
    //         },
    //         {
    //             id: "products-active",
    //             title: "Active",
    //             role: ["admin"],
    //             link: "/products/active",
    //         },
    //         {
    //             id: "products-disabled",
    //             title: "Disabled",
    //             role: ["admin"],
    //             link: "/products/disabled",
    //         },
    //     ]
    // },
    // {
    //     id: "products",
    //     title: "Master Products",
    //     role: ["admin"],
    //     logo: (active) => <PackageIcon active={active} />,
    //     items: [
    //         {
    //             id: "icategory",
    //             title: "iCategory",
    //             role: ["admin"],
    //             link: "/icategory",
    //         },
    //         {
    //             id: "category",
    //             title: "Category",
    //             role: ["admin"],
    //             link: "/category",
    //         },
    //         {
    //             id: "product-types",
    //             title: "Product Types",
    //             role: ["admin"],
    //             link: "/product-types",
    //         },
    //         {
    //             id: "product-image",
    //             title: "Product Image",
    //             role: ["admin"],
    //             link: "/product-image",
    //         },
    //     ]
    // },
    // {
    //     id: "supplier-types",
    //     title: "Supplier Types",
    //     link: "/supplier-types",
    //     role: ["admin"],
    //     logo: (active) => <SupplierIcon active={active} />
    // },
    // {
    //     id: "certified",
    //     title: "Certified By",
    //     link: "/certified",
    //     role: ["admin"],
    //     logo: (active) => <CertifiedIcon active={active} />
    // },
];
